import React from 'react';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined';
import AirportShuttleOutlinedIcon from '@mui/icons-material/AirportShuttleOutlined';
import DirectionsBusOutlinedIcon from '@mui/icons-material/DirectionsBusOutlined';

/** Five fixed color presets for vehicle type badges (table + detail). */
export const VEHICLE_TYPE_COLOR_PRESETS = [
  {
    key: 'truck',
    label: 'Truck',
    match: ['truck'],
    bg: '#dbeafe',
    color: '#1d4ed8',
    icon: 'truck' as const,
  },
  {
    key: 'tempo',
    label: 'Tempo / Van',
    match: ['tempo', 'traveller', 'van'],
    bg: '#ede9fe',
    color: '#6d28d9',
    icon: 'tempo' as const,
  },
  {
    key: 'car',
    label: 'Car / SUV',
    match: ['car', 'suv', 'sedan'],
    bg: '#dcfce7',
    color: '#15803d',
    icon: 'car' as const,
  },
  {
    key: 'mini',
    label: 'Mini Truck',
    match: ['mini'],
    bg: '#fce7f3',
    color: '#db2777',
    icon: 'mini' as const,
  },
  {
    key: 'bus',
    label: 'Bus',
    match: ['bus'],
    bg: '#f3e8ff',
    color: '#7c3aed',
    icon: 'bus' as const,
  },
] as const;

export type VehicleTypePreset = (typeof VEHICLE_TYPE_COLOR_PRESETS)[number];

export function resolveVehicleTypePreset(type: string): VehicleTypePreset {
  const t = String(type || '').toLowerCase();
  for (const preset of VEHICLE_TYPE_COLOR_PRESETS) {
    if (preset.match.some((m) => t.includes(m))) return preset;
  }
  return VEHICLE_TYPE_COLOR_PRESETS[0];
}

export function vehicleTypeIcon(preset: VehicleTypePreset, fontSize = 13): React.ReactNode {
  const sx = { fontSize };
  switch (preset.icon) {
    case 'bus':
      return <DirectionsBusOutlinedIcon sx={sx} />;
    case 'tempo':
      return <AirportShuttleOutlinedIcon sx={sx} />;
    case 'car':
      return <DirectionsCarFilledOutlinedIcon sx={sx} />;
    case 'mini':
      return <LocalShippingOutlinedIcon sx={sx} />;
    default:
      return <LocalShippingOutlinedIcon sx={sx} />;
  }
}

export function masterVehicleName(row: Record<string, unknown>, keys: string[]): string {
  for (const key of keys) {
    const v = String(row[key] || '').trim();
    if (v && !/^[a-f0-9]{24}$/i.test(v)) return v;
  }
  return '—';
}

export function ownershipLabel(row: Record<string, unknown>): string {
  const t = String(row.ownerType || 'owned').toLowerCase();
  if (t === 'leased' || t === 'rented') return 'Vendor leased';
  return 'Owned';
}
